import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { Box, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// routes
import { PATH_AUTH } from '../../../routes/paths';
// components
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import axios from 'axios';
import { API_ENDPOINTS } from 'src/api/apiEndPoints';
import { SentIcon } from 'src/assets';
import { useState } from 'react';

// ----------------------------------------------------------------------

export default function ResetPasswordForm() {
  const navigate = useNavigate();

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
  });
  const [view, setView] = useState('forget')
  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { email: '' },
  });
  const [value, setValue] = useState({})
  const {
    setError,

    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    setValue(data)
    try {
      await axios.post(API_ENDPOINTS.INS_RESET_PASSWORD, data)

      // sessionStorage.setItem('email-recovery', data.email);
      setView('success')
      // navigate(PATH_AUTH.newPassword);
    } catch (error) {
      setError("email", {
        type: "manual",
        message: error.response.data?.email?.join(","),
      });
      console.error(error.response);
    }
  };

  return (<>
    {view == 'forget' ? <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h3" paragraph sx={{ color: '#ffffff', shadow:'0'}}>
        Forgot your password?
      </Typography>
      

      <Typography sx={{ color: 'text.secondary', mb: 5 }}>
        Please enter the email address associated with your account and We will email you a link to reset your
        password.
      </Typography>
      <Stack spacing={3}>
        <RHFTextField name="email" label="Email address"  color="secondary"
                    
                    sx={{ input: { color: 'white' } }}  />

        <LoadingButton sx={{ bgcolor: '#E61471!important', shadow:'0'}} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Send Request
        </LoadingButton>
      </Stack>
    </FormProvider>
      : <Box sx={{ textAlign: 'center' }}>
        <SentIcon sx={{ mb: 5, mx: 'auto', height: 160 }} />

        <Typography variant="h3" gutterBottom sx={{color: '#ffffff'}}>
          Request sent successfully
        </Typography>
        <Typography sx={{color: '#ffffff'}}>
          We have sent a confirmation email to &nbsp;
          <strong>{value.email}</strong>
          <br />
          Please check your email.
        </Typography>

      </Box>}
  </>
  );
}
